import angular from 'angular';
import {UpgradeController, upgrade} from './upgrade-component';

export default angular.module('mapmycustomersApp.upgrade', [])
  .controller('UpgradeController', UpgradeController)
  .component('upgrade', upgrade)
  .name;
